import React from "react";
import "./styles.scss";
const Loader = () => {
  return (
    <div className="modal-loader">
      <div className="modal-content-loader">
        <div className="loader"></div>
      </div>
    </div>
  );
};

export default Loader;
